import styled from '@emotion/styled';
import React, { ReactElement, useState } from 'react';
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { Select, SelectOption } from '../../Select/component';
import { ChartSpinnerOverlay } from '../ChartSpinnerOverlay/component';

export interface UsageOverTimeDataItem {
  name: string;
  amount: number;
}

export type UsageOverTimeData = UsageOverTimeDataItem[];

interface UsageOverTimeChartProps {
  title: string | ReactElement;
  data: UsageOverTimeData;
  selectOptions: SelectOption[];
  isLoading: boolean;
  onChange(value: string): void;
}

const Title = styled('div')({
  fontSize: 16,
  fontWeight: 600,
});

const ContentHeader = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

const ContentBody = styled('div')({
  position: 'relative',
});

export const UsageOverTimeChart = React.memo(
  ({
    title,
    isLoading,
    data,
    selectOptions,
    onChange,
  }: UsageOverTimeChartProps): ReactElement => {
    const [selectValue, setSelectValue] = useState(
      selectOptions[0] && selectOptions[0].value
    );

    const onValueChange = (value: string): void => {
      setSelectValue(value);
      onChange(value);
    };

    return (
      <>
        <ContentHeader>
          <Title>{title}</Title>
          <Select
            value={selectValue}
            options={selectOptions}
            onValueChange={onValueChange}
          />
        </ContentHeader>
        <ContentBody>
          <ResponsiveContainer width="100%" height={300}>
            <ComposedChart data={data}>
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis dataKey="name" />
              <YAxis
                label={{
                  value: 'Learners',
                  angle: -90,
                  position: 'insideLeft',
                }}
              />
              <Tooltip />
              <Bar dataKey="amount" barSize={20} fill="#094967" />
            </ComposedChart>
          </ResponsiveContainer>
          {isLoading && <ChartSpinnerOverlay />}
        </ContentBody>
      </>
    );
  }
);
